// Generated by scripts/generate-english-i18n.js. Do not edit directly.
export default {
  "googleAuth": {
    "or": "or",
    "processing": "Verifying your Google account…",
    "configMissing": "Google sign-in has not been configured",
    "unavailable": "Google sign-in is temporarily unavailable",
    "failed": "Google sign-in failed. Please try again",
    "invalidResponse": "The login service did not return a valid credential",
    "success": "Signed in with Google",
    "inviteTitle": "Enter invitation code",
    "inviteDescription": "This Google account is signing in for the first time. Enter a valid invitation code to create your account. Future sign-ins will continue directly.",
    "cancel": "Cancel",
    "continue": "Continue"
  },
  "loginUi": {
    "memberWindow": "Member Login",
    "noAccount": "No account?",
    "signUpNow": "Sign up now",
    "customerService": "Customer Service",
    "forgotPassword": "Forgot password?"
  },
  "appUi": {
    "languageSelection": "Language Selection",
    "home": "Home",
    "feedback": "Feedback",
    "vote": "Vote",
    "cinema": "Cinema",
    "mine": "Mine",
    "sponsorship": "Sponsorship",
    "customerService": "Customer Service",
    "videos": "Videos",
    "managerProfile": "Manager Profile",
    "popularCities": "Popular Cities",
    "managerReservation": "Manager Reservation",
    "more": "More",
    "certification": "Certification",
    "noData": "No data",
    "height": "Height",
    "bust": "Bust",
    "serviceCity": "Service City",
    "nationalAirborne": "National Airborne",
    "yes": "Yes",
    "all": "All",
    "highestRated": "Highest Rated",
    "lowestRated": "Lowest Rated",
    "views": "Views",
    "loading": "Loading...",
    "releaseToRefresh": "Release to refresh",
    "noMore": "No more",
    "register": "Register",
    "usernamePlaceholder": "Please enter your username",
    "usernameHint": "Please enter 6–20 letters and numbers",
    "passwordPlaceholder": "Please enter your password",
    "passwordHint": "Please enter 6–16 letters and numbers",
    "invitationPlaceholder": "Please enter invitation code",
    "invitationHint": "Enter the agent invitation code.",
    "agreement": "I am 18 years old and agree to the account opening terms",
    "registerSubmit": "Complete registration",
    "usernameLength": "Username must be 6 to 20 characters long",
    "usernameFormat": "Username can only contain letters and numbers",
    "passwordLength": "Password must be 6 to 16 characters long",
    "registrationSuccess": "Registration successful",
    "registrationFailed": "Registration failed. Please try again",
    "registrationRequestFailed": "Registration request failed. Please try again",
    "settings": "Settings",
    "basicInformation": "Basic Information",
    "loginPassword": "Login Password",
    "financePassword": "Finance Password",
    "logout": "Logout",
    "accountInformation": "Account Information",
    "changeLoginPassword": "Change Login Password",
    "setPaymentPassword": "Set Payment Password",
    "avatar": "Avatar",
    "realName": "Real Name",
    "sex": "Sex",
    "notSet": "Not Set",
    "male": "Male",
    "female": "Female",
    "submit": "Submit",
    "points": "Points",
    "period": "Period",
    "taskAmount": "Task Amount",
    "recharge": "Recharge",
    "paymentMethod": "Payment Method",
    "actualReceipt": "Actual Receipt",
    "fee": "Fee",
    "onlineService": "Online customer service",
    "contact": "Contact",
    "exchangePoints": "Exchange Points",
    "withdrawalType": "Withdrawal Type",
    "crypto": "Crypto",
    "bookingHall": "Booking Hall",
    "withdrawFrozenTitle": "Account frozen",
    "withdrawFrozenMessage": "Please check your account status for details.",
    "withdrawFrozenHint": "Withdrawals are currently unavailable. Please contact customer service.",
    "withdrawFrozenConfirm": "OK",
    "cryptoAddressBook": "Withdrawal Address",
    "systemMessages": "System Messages",
    "vipCenter": "VIP Center",
    "bindWithdrawalAddress": "Bind a withdrawal address first",
    "manageWithdrawalAddress": "Manage withdrawal address",
    "bindAddressFirst": "Please bind a withdrawal address first.",
    "currentVipLevel": "Current VIP Level",
    "vipAccountStatus": "Membership Status",
    "vipStatusActive": "Active",
    "vipDescription": "Your VIP level is synchronized with your account. Contact customer service for level details and assistance.",
    "myPage": "My Page",
    "loginRegister": "Login / Register",
    "creditScore": "Credit score",
    "vipBanner": "Activate and verify your dating card\nEnjoy unlimited dating",
    "withdrawalCenter": "Withdrawal Center",
    "sponsoredHistory": "Sponsored Transaction History",
    "depositHistory": "Deposit History",
    "withdrawalHistory": "Withdrawal History",
    "loanCenter": "Loan Center",
    "loanRepayment": "Loan Repayment",
    "loanRecords": "Loan Records",
    "unavailable": "Function is not available yet"
  },
  "chooseUi": {
    "designed": "DESIGNED FOR REAL CONNECTIONS",
    "why": "Why Choose Us?",
    "intro": "A more private and comfortable way to meet someone special.",
    "sameCity": "Same-city matching",
    "nearby": "Meet compatible people nearby.",
    "realChat": "Real chat",
    "trust": "Build trust through real conversations.",
    "safePrivate": "Safe and private",
    "privacy": "Your privacy always comes first.",
    "stories": "COMMUNITY STORIES",
    "feedback": "User Feedback",
    "loadingFeedback": "Loading feedback",
    "memberStory": "Member story",
    "shared": "Shared experience",
    "noFeedback": "No feedback yet",
    "firstShare": "Be the first to share your experience.",
    "shareStory": "Share your story",
    "leaveComment": "Leave a comment",
    "postComment": "Post a Comment",
    "name": "Name",
    "displayName": "Display name (optional)",
    "comment": "Comment",
    "shareExperience": "Share your experience",
    "recently": "Recently",
    "minimum": "Please enter at least 10 characters.",
    "submitFailed": "Submission failed.",
    "submitted": "Submitted for review.",
    "networkFailed": "Network request failed",
    "loading": "Loading...",
    "noImages": "No images available",
    "noRating": "No rating yet",
    "noDetailImages": "No detail images available",
    "unknown": "Unknown"
  },
  "lotteryUi": {
    "purchaseNumber": "Purchase Number (Auto-update every 3 minutes)",
    "records": "Records",
    "purchaseAmount": "Please enter purchase amount",
    "selectedItems": "Selected Items",
    "estimatedDeduction": "Estimated Deduction",
    "currentBalance": "Current Balance",
    "submitPurchase": "Submit Purchase",
    "submitting": "Submitting...",
    "confirmSubmit": "Confirm Submit",
    "orderRecords": "Order Records",
    "noOrderRecords": "No Order Records",
    "selection": "Selection",
    "closeRecords": "Close order records"
  },
  "extendedUi": {
    "ok": "OK",
    "back": "Back",
    "browserSupport": "A browser that supports HTML5 video is required.",
    "creditNoticeTitle": "Credit score notice",
    "creditNoticeContent": "Your credit score has dropped to {score}. Please contact customer service for assistance.",
    "uploadSuccess": "Upload successful",
    "completeForm": "Please complete the form",
    "passwordMismatch": "Passwords do not match",
    "oldSixDigitPassword": "Please enter a 6-digit old password",
    "sixDigitPassword": "Please enter a 6-digit password",
    "cacheManagement": "Cache Management",
    "cacheStatistics": "Cache Statistics",
    "memoryCache": "Memory Cache",
    "indexedResources": "IndexedDB Resources",
    "indexedImages": "IndexedDB Images",
    "indexedApi": "IndexedDB API",
    "cacheActions": "Cache Actions",
    "cleanExpiredCache": "Clean Expired Cache",
    "clearAllCache": "Clear All Cache",
    "preloadResources": "Preload Resources",
    "cacheDetails": "Cache Details",
    "hideDetails": "Hide Details",
    "showDetails": "Show Details",
    "cacheStatsFailed": "Failed to get cache statistics",
    "expiredCacheCleaned": "Expired cache cleaned",
    "expiredCacheFailed": "Failed to clean expired cache",
    "confirmClear": "Confirm Clear",
    "allCacheCleared": "All cache has been cleared",
    "clearCacheFailed": "Failed to clear cache",
    "resourcesPreloaded": "Resources preloaded",
    "preloadFailed": "Failed to preload resources",
    "paymentCardIntro": "Please enter your payment card information",
    "confirmCardBinding": "Confirm Card Binding",
    "bankName": "Bank Name",
    "branchName": "Branch Name",
    "branchCode": "Branch Code",
    "bankAccountNumber": "Bank Account Number",
    "enterName": "Please enter name",
    "completeBankInfo": "Please complete the bank card information",
    "bankCardInfo": "Bank Card Info",
    "bankReminder": "Reminder: Please bind a major commercial bank. Contact online customer service for changes.",
    "creditLimit": "Credit Limit",
    "exclusiveCredit": "Enjoy Exclusive Credit Services",
    "availableCredit": "Available Credit",
    "quotaRange": "Quota Range",
    "dailyRate": "Daily Rate",
    "loanAmount": "Loan Amount",
    "repaymentTerm": "Repayment Term",
    "interestAmount": "Interest Amount",
    "totalRepayment": "Total Repayment",
    "applyNow": "Apply Now",
    "loanNoteAbility": "Note: Ensure you have sufficient repayment ability",
    "loanNoteCareful": "Borrow carefully. Timely repayment helps improve credit.",
    "customAmount": "Please enter a custom amount",
    "validAmount": "Please enter a valid amount",
    "applicationSuccess": "Application successful",
    "noRecords": "No Records Available",
    "loanOrder": "Loan Order",
    "borrower": "Borrower",
    "loanTerm": "Loan Term",
    "days": "days",
    "totalAmount": "Total Amount",
    "applyTime": "Apply Time",
    "expireTime": "Expire Time",
    "rejectReason": "Reject Reason",
    "repayNow": "Repay Now",
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "completed": "Completed",
    "confirmRepayment": "Confirm Repayment",
    "repaymentMessage": "Please confirm the repayment information before proceeding.",
    "repaymentSuccess": "Repayment successful",
    "watchHistory": "Watch history",
    "ticketHistory": "Ticket history",
    "watched": "Watched",
    "issue": "Issue",
    "unknownTime": "Unknown time",
    "justNow": "Just now",
    "minutesAgo": "minutes ago",
    "hoursAgo": "hours ago",
    "daysAgo": "days ago",
    "confirmDeletion": "Confirm deletion",
    "currentBalance": "Current balance",
    "unit": "Unit",
    "rechargeAmount": "Please enter recharge amount",
    "incorrectAmount": "Incorrect amount",
    "orderTime": "Order Time",
    "dedicatedService": "24/7 Dedicated Service",
    "serviceUnavailable": "Service is unavailable",
    "withdrawalAmount": "Withdrawal Amount",
    "fundPassword": "Fund Password",
    "cryptoAddress": "Cryptocurrency Address",
    "notification": "Notification",
    "maxSingleWithdrawal": "Maximum single withdrawal amount",
    "minSingleWithdrawal": "Minimum withdrawal amount for a single transaction",
    "checkWithdrawalAccount": "Please check your name and withdrawal account number",
    "knowWithdrawalFees": "Know the withdrawal fees",
    "validWithdrawalAmount": "Please enter a valid withdrawal amount",
    "enterFundPassword": "Please enter fund password",
    "enterCryptoAddress": "Please enter cryptocurrency address",
    "exchangeRecord": "Exchange Record",
    "exchange": "Exchange",
    "view": "View",
    "twoHoursAgo": "2 hours ago",
    "notSelected": "Not selected",
    "item1": "Item 1",
    "item2": "Item 2",
    "item3": "Item 3",
    "item4": "Item 4",
    "accountActions": "Account actions",
    "userAvatar": "User Avatar",
    "refreshStatistics": "Refresh Statistics",
    "items": "items",
    "cardSafetyWarning": "Dear user, to keep your funds safe, please link your real name and set a withdrawal password. The account name must match your real name.",
    "interestRate": "Interest Rate",
    "minimumLoanAmount": "Minimum loan amount",
    "maximumLoanAmount": "Maximum loan amount",
    "trialTimeRemaining": "Trial time remaining: {seconds} seconds",
    "noTags": "No tags available",
    "outstandingLoans": "Outstanding",
    "repaymentHistory": "Repaid",
    "outstandingTotal": "Outstanding Total",
    "availableBalance": "Available Balance",
    "principal": "Principal",
    "dueDate": "Due Date",
    "repaidTime": "Repaid Time",
    "noOutstandingLoans": "No outstanding loans",
    "noRepaymentHistory": "No repayment history",
    "repaymentAmount": "Repayment Amount",
    "repaymentAmountPlaceholder": "Enter amount",
    "remainingRepayment": "Remaining",
    "confirmRepaymentAmount": "Submit a repayment request for loan #{order} for {amount}? Your balance will remain unchanged until an administrator approves it.",
    "invalidRepaymentAmount": "Please enter a valid repayment amount.",
    "repaymentExceedsOutstanding": "The repayment amount cannot exceed the outstanding balance.",
    "insufficientRepaymentBalance": "Your available balance is not enough to repay this loan.",
    "repaymentProcessing": "Submitting repayment request...",
    "partialRepaymentSuccess": "Repayment successful. Remaining amount: {amount}",
    "repaymentSupportRedirect": "Redirecting to customer service in 3 seconds...",
    "rechargeSupportRedirect": "Redirecting to online customer service in 1.5 seconds...",
    "overdue": "Overdue"
  }
}
